(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("siteheader", ["jquery", "betteroffcanvas"], factory);
    } else {
        // Browser globals
        root.siteheader = factory(root.jQuery, root.betteroffcanvas);
    }
}(this, function ($, betteroffcanvas, ajaxCart, Handlebars) {
    "use strict";
    "feel good";

    var $window = $(window);

    if( $window.width() > 1024 ) {
        var headerHeight = $("header.fl-builder-content .fl-row-content-wrap").outerHeight();
        $("header.fl-builder-content .fl-row-content-wrap").css( "height", headerHeight );
    }
    
    $("header.fl-builder-content .dropdown-item").click(function (e) {
        var $this = $(this);
        e.stopPropagation();

        var subMenuHeightCalc = $this.find('.sub-menu').outerHeight();
        var headerSubMenuHeightSum = headerHeight + subMenuHeightCalc;

        if(e.ctrlKey || e.metaKey) {

            console.log('ctrl/cmd is active');
            
        } else {

            if( $window.width() > 1024 ) {
                $("header.fl-builder-content .fl-row-content-wrap").css( "height", headerSubMenuHeightSum + 10 );
            }

            if ($this.hasClass('dropdown-item--activated')) {

                $this.removeClass('dropdown-item--activated');
                $this.find('.sub-menu').slideUp(500);
    
                if( $window.width() > 1024 ) {
                    $("header.fl-builder-content .fl-row-content-wrap").css( "height", headerHeight );
                }
            } else {
                
                $this.parents('header.fl-builder-content').find('li.menu-item').removeClass('dropdown-item--activated');
                $this.parents('header.fl-builder-content').find(".sub-menu").css( "display", "none" );
    
                $this.find('.sub-menu').slideDown(500);
    
                $this.addClass('dropdown-item--activated');
            }
        }
    });
    
    $(document).on('click', function() {
        $('header.fl-builder-content li.menu-item').removeClass('dropdown-item--activated');

        if( $window.width() > 1024 ) {
            $("header.fl-builder-content .fl-row-content-wrap").css( "height", headerHeight );
        }
    });

    $("header.fl-builder-content .dropdown-item a[href='#']").click(function (e) {
        e.preventDefault();
    });

}));
